const totalSet = (tableName, totalValues) => {
  let headers = [];
  let totals  = [];

  if (totalValues) {
    const { 
      total, difference, subtotalA, subtotalN 
    } = totalValues;

    switch(tableName) {
      case 'AccountStatement':
        headers = ["Asociado", "No Asociado", "Diferencia", "Total"];
        totals = [
          subtotalA, 
          subtotalN, 
          difference, 
          total, 
        ];
        break;
      default:
    }
  }
  return {headers, totals};
}

export default totalSet;